import {
  FocusTrapProps as MantineFocusTrapProps,
  FocusTrap as MantineFocusTrap,
  FocusTrapInitialFocus as MantineFocusTrapInitialFocus,
} from '@mantine/core';
import { ComponentPropsWithoutRef } from 'react';

export type FocusTrapProps = MantineFocusTrapProps;
export type FocusTrapInitialFocusProps = ComponentPropsWithoutRef<'span'>;

export const FocusTrap = (props: FocusTrapProps) => {
  return <MantineFocusTrap {...props} />;
};

FocusTrap.displayName = 'FocusTrap';

export const FocusTrapInitialFocus = (props: FocusTrapInitialFocusProps) => {
  return <MantineFocusTrapInitialFocus {...props} />;
};

FocusTrapInitialFocus.displayName = 'FocusTrapInitialFocus';
